import type { SVGProps } from 'react';
const SvgCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M199.944 300.11c-5.43-2.88-11.104-5.563-16.867-7.824-17.267-6.782-24.537-18.929-36.595-26.554-18.93-11.969-41.693-21.411-77.8-21.411-36.706 0-66.496 29.79-66.496 66.496 0 36.683 29.79 66.496 66.495 66.496 12.834 0 16.026 8.223 22.41 13.277 11.924 9.442 25.379 18.419 43.421 25.49 16.979 6.671 24.493 16.402 30.3 20.902 8.201 6.361 15.96 10.572 23.119 13.299 19.505 7.447 38.213 7.47 58.583-1.862 11.237-5.143 29.036-17.533 50.47-51.579 21.456-34.09 47.19-85.38 79.795-131.617 24.315-34.49 51.357-67.937 87.487-78.576 35.198-10.352 55.368-47.345 45.017-82.566-10.351-35.199-47.345-55.369-82.565-45.018-51.779 15.228-97.129 51.845-134.965 98.237-37.127 45.483-67.072 100.475-91.809 142.81Z" />
  </svg>
);
export default SvgCheckmark;
